export default __webpack_public_path__ + "assets/_Chapters/Karriere/Berufserfahrene/berufserfahrene-outtakes-standbild.webp";